import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const useMockData = false
const resource = 'special-rights'

const mockSource = [
  {
    id: 'sr-1',
    org_codename: 'psuv',
    rights_type: 'government',
    title_th: 'สิทธิเบิกจ่ายตรงราชการ',
    title_en: 'Civil Servant Direct Billing',
    description_th: 'สำหรับสิทธิข้าราชการ',
    description_en: 'For government officer benefit',
    conditions_th: 'แสดงบัตรข้าราชการ',
    conditions_en: 'Present government officer card',
    updated_at: '2026-09-30T10:00:00Z'
  },
  {
    id: 'sr-2',
    org_codename: 'ppnp',
    rights_type: 'education',
    title_th: 'ส่วนลดนักเรียน/นักศึกษา',
    title_en: 'Student Health Discount',
    description_th: 'ส่วนลดสำหรับนักเรียน/นักศึกษา',
    description_en: 'Discount for students',
    conditions_th: 'แสดงบัตรนักเรียน',
    conditions_en: 'Present student card',
    updated_at: '2026-09-29T10:00:00Z'
  },
  {
    id: 'sr-3',
    org_codename: 'psuv',
    rights_type: 'treatment',
    title_th: 'สิทธิประกันสังคม',
    title_en: 'Social Security Fund Coverage',
    description_th: 'สิทธิรักษาประกันสังคม',
    description_en: 'Social security treatment right',
    conditions_th: 'ตามเงื่อนไขประกันสังคม',
    conditions_en: 'Subject to SSO conditions',
    updated_at: '2026-09-28T10:00:00Z'
  }
]

const defaultState = () => ({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  sortBy: 'updated_at',
  sortDesc: 'DESC',
  textSearch: '',
  filterOrgCode: '',
  filterRightsType: '',
  list: [],
  isLoading: false,
  isSaving: false,
  orgOptions: []
})

const state = defaultState()
const generateMockId = (prefix) => `${prefix}-${Date.now()}-${Math.floor(Math.random() * 100000)}`

const actions = {
  setResource() {},
  resetList({commit}) { commit('RESET_LIST_STATE') },
  setTextSearch({commit}, text) { commit('SET_TEXT_SEARCH', text) },
  setFilterOrgCode({commit}, orgCode) { commit('SET_FILTER_ORG_CODE', orgCode) },
  setFilterRightsType({commit}, rightsType) { commit('SET_FILTER_RIGHTS_TYPE', rightsType) },
  async fetchOrgOptions({commit}) {
    if (useMockData) {
      commit('SET_ORG_OPTIONS', [
        {text: 'psuv - Princ Suvarnabhumi', value: 'psuv'},
        {text: 'ppnp - Princ Pak Nam Pho', value: 'ppnp'},
        {text: 'pkkp - Princ Khon Kaen', value: 'pkkp'}
      ])
      return
    }
    try {
      const response = await client.secureHttpClient.get('/por/api/organization/permission?permission=View&category=Organization')
      const data = response?.data?.data || response?.data || []
      commit('SET_ORG_OPTIONS', (data || []).map((item) => {
        const codename = String(item.codename || item.value || '').toLowerCase()
        const name = item.name || item.name_th || item.text || codename.toUpperCase()
        return { text: `${codename} - ${name}`, value: codename }
      }).filter(item => item.value))
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_ORG_OPTIONS', [])
    }
  },
  async fetch({commit, state}) {
    commit('SET_IS_LOADING', true)
    if (useMockData) {
      let data = [...mockSource]
      if (state.filterOrgCode) data = data.filter(item => item.org_codename === state.filterOrgCode)
      if (state.filterRightsType) data = data.filter(item => item.rights_type === state.filterRightsType)
      if (state.textSearch) {
        const term = state.textSearch.toLowerCase()
        data = data.filter(item => `${item.title_th || ''} ${item.title_en || ''} ${item.rights_type || ''}`.toLowerCase().includes(term))
      }
      commit('SET_LIST', data)
      commit('SET_TOTAL', data.length)
      commit('SET_IS_LOADING', false)
      return
    }

    try {
      const response = await client.secureHttpClient.get(`/por/api/${resource}`, {
        params: {
          page: state.currentPage,
          limit: state.pageSize,
          orderBy: state.sortBy,
          sort: state.sortDesc,
          search: state.textSearch,
          org_codename: state.filterOrgCode,
          rights_type: state.filterRightsType
        },
        paramsSerializer: localParams => qs.stringify(localParams, {encode: false})
      })
      const resData = response?.data || {}
      const list = resData.results || resData.data || []
      const total = resData.total !== undefined ? resData.total : list.length
      commit('SET_LIST', Array.isArray(list) ? list : [])
      commit('SET_TOTAL', total)
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_LIST', [])
      commit('SET_TOTAL', 0)
    }
    commit('SET_IS_LOADING', false)
  },
  async save({commit}, payload) {
    commit('SET_IS_SAVING', true)
    if (useMockData) {
      if (payload.id) {
        const index = mockSource.findIndex(item => item.id === payload.id)
        if (index !== -1) mockSource[index] = {...mockSource[index], ...payload, updated_at: new Date().toISOString()}
      } else {
        mockSource.unshift({...payload, id: generateMockId('sr'), updated_at: new Date().toISOString()})
      }
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    }
    try {
      if (payload.id) await client.secureHttpClient.put(`/por/api/${resource}/${payload.id}`, payload)
      else await client.secureHttpClient.post(`/por/api/${resource}`, payload)
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_SAVING', false)
      return {ok: false, message: e?.response?.data?.message || 'Unable to save'}
    }
  },
  async deleteById(_context, id) {
    if (useMockData) {
      const index = mockSource.findIndex(item => item.id === id)
      if (index !== -1) mockSource.splice(index, 1)
      return true
    }
    try {
      await client.secureHttpClient.delete(`/por/api/${resource}/${id}`)
      return true
    } catch (e) {
      Vue.$log.error(e)
      return false
    }
  }
}

const mutations = {
  RESET_LIST_STATE(state) {
    state.currentPage = 1
    state.pageSize = 10
    state.total = 0
    state.sortBy = 'updated_at'
    state.sortDesc = 'DESC'
    state.textSearch = ''
    state.filterOrgCode = ''
    state.filterRightsType = ''
    state.list = []
  },
  SET_TEXT_SEARCH(state, text) { state.textSearch = text },
  SET_FILTER_ORG_CODE(state, orgCode) { state.filterOrgCode = orgCode },
  SET_FILTER_RIGHTS_TYPE(state, rightsType) { state.filterRightsType = rightsType },
  SET_LIST(state, list) { state.list = list },
  SET_TOTAL(state, total) { state.total = total },
  SET_IS_LOADING(state, isLoading) { state.isLoading = isLoading },
  SET_IS_SAVING(state, isSaving) { state.isSaving = isSaving },
  SET_ORG_OPTIONS(state, orgOptions) { state.orgOptions = orgOptions }
}

export default { namespaced: true, state, actions, mutations }
